import { getOrganizationId } from "./organizationUtils";

/**
 * Resolve organizationId from user context, with localStorage fallbacks
 * used elsewhere in the app (dashboard, apiClient).
 */
export const resolveOrganizationId = (user) => {
  const fromUser = getOrganizationId(user);
  if (fromUser) return fromUser;

  const fromStorage = localStorage.getItem("organizationId");
  if (fromStorage != null && fromStorage !== "" && !isNaN(fromStorage)) {
    const num = Number(fromStorage);
    if (num > 0) return num;
  }

  return null;
};

/**
 * Wait briefly for organizationId after login (org users only).
 * Resolves immediately when already available.
 */
export const waitForOrganizationId = (user, timeoutMs = 8000) =>
  new Promise((resolve) => {
    const existing = resolveOrganizationId(user);
    if (existing) {
      resolve(existing);
      return;
    }

    let settled = false;
    const finish = (orgId) => {
      if (settled) return;
      settled = true;
      clearTimeout(timer);
      window.removeEventListener("userOrganizationIdUpdated", onUpdate);
      resolve(orgId);
    };

    const onUpdate = (event) => {
      const orgId =
        resolveOrganizationId(event?.detail?.updatedUser) ||
        resolveOrganizationId(user);
      if (orgId) finish(orgId);
    };

    const timer = setTimeout(() => finish(null), timeoutMs);
    window.addEventListener("userOrganizationIdUpdated", onUpdate);
  });
